import { Link } from 'react-router-dom';
import UtilityBar from '../components/layout/UtilityBar';
import Nav from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import ImageSlot from '../components/ui/ImageSlot';
import { BLOG_POSTS, BLOG_CATEGORIES } from '../data/blogPosts';

/** Blog index — "The Lincoln Journal". Magazine list layout. */
export default function BlogIndex() {
  return (
    <div className="bg-white">
      <UtilityBar />
      <Nav variant="light" />

      <section style={{ background: 'var(--bg-cream)', padding: '72px 0 0', borderBottom: '1px solid var(--line)' }}>
        <div className="lc-container">
          <div className="text-center pb-10" style={{ maxWidth: 760, margin: '0 auto' }}>
            <span className="lc-eyebrow">The Lincoln Journal</span>
            <h1 className="mt-3.5" style={{ fontSize: 64, letterSpacing: '-0.03em', lineHeight: 1 }}>
              Stories from the <em className="italic" style={{ color: 'var(--blue)' }}>work</em>.
            </h1>
            <p className="mt-4 leading-relaxed mx-auto" style={{ fontSize: 17, color: 'var(--muted)', maxWidth: 560 }}>
              Case studies, project notes, and research from the field.
            </p>

            <div className="bg-white flex items-center gap-2 mx-auto mt-7"
              style={{ borderRadius: 14, padding: 6, boxShadow: 'var(--shadow-sm)', border: '1px solid var(--line)', maxWidth: 520 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2.4" style={{ marginLeft: 10 }}>
                <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
              </svg>
              <input
                placeholder="Search stories…"
                className="flex-1 outline-none"
                style={{ border: 0, fontSize: 14, padding: '8px 0', color: 'var(--ink)', fontFamily: 'inherit', background: 'transparent' }}
              />
              <button type="button" className="lc-btn primary sm">Search</button>
            </div>
          </div>

          <div className="lc-hide-scrollbar flex items-center justify-center overflow-x-auto" style={{ gap: 4 }}>
            {BLOG_CATEGORIES.map((c, i) => (
              <button key={c.name} type="button" className="font-semibold whitespace-nowrap"
                style={{
                  padding: '12px 20px', fontSize: 14,
                  color: i === 0 ? 'var(--ink)' : 'var(--muted)',
                  borderBottom: i === 0 ? '3px solid var(--yellow)' : '3px solid transparent',
                  marginBottom: -1,
                }}>
                {c.name} <span className="ml-1 font-medium" style={{ color: i === 0 ? 'var(--muted)' : 'var(--muted-2)' }}>({c.count})</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured post */}
      <section className="lc-section tight" style={{ paddingTop: 56 }}>
        <div className="lc-container">
          <FeaturedPost post={BLOG_POSTS[0]} />
        </div>
      </section>

      {/* Magazine list + sidebar */}
      <section style={{ paddingBottom: 100 }}>
        <div className="lc-container">
          <div className="grid" style={{ gridTemplateColumns: '1fr 320px', gap: 64 }}>
            <div>
              <div className="flex justify-between items-center mb-8">
                <h2 style={{ fontSize: 28 }}>Latest stories</h2>
                <div className="flex items-center gap-2" style={{ fontSize: 13, color: 'var(--muted)' }}>
                  Sort by:
                  <select className="bg-white" style={{ border: '1px solid var(--line)', borderRadius: 6, padding: '6px 10px', fontFamily: 'inherit', fontSize: 13 }}>
                    <option>Newest first</option>
                    <option>Most read</option>
                    <option>Editor&apos;s picks</option>
                  </select>
                </div>
              </div>
              {BLOG_POSTS.slice(1, 8).map((p) => (
                <BlogListItem key={p.slug} post={p} />
              ))}
              <div className="flex justify-center mt-12 gap-1.5">
                {[1, 2, 3, 4, 5, '…', 9].map((p, i) => (
                  <button key={i} type="button" className="font-semibold"
                    style={{
                      width: 40, height: 40, borderRadius: 10, fontSize: 14,
                      background: p === 1 ? 'var(--navy)' : '#fff',
                      color: p === 1 ? '#fff' : 'var(--ink)',
                      border: p === 1 ? 'none' : '1px solid var(--line)',
                    }}>{p}</button>
                ))}
                <button type="button" className="bg-white font-semibold"
                  style={{ height: 40, padding: '0 16px', borderRadius: 10, fontSize: 14, border: '1px solid var(--line)', color: 'var(--ink)' }}>Next →</button>
              </div>
            </div>

            <aside>
              <div className="sticky flex flex-col gap-6" style={{ top: 100 }}>
                <div className="text-white" style={{ background: 'var(--navy)', borderRadius: 16, padding: 24 }}>
                  <span className="font-bold tracking-widest" style={{ fontSize: 11, color: 'var(--yellow-2)' }}>NEWSLETTER</span>
                  <h3 className="text-white mt-2" style={{ fontSize: 22, lineHeight: 1.2 }}>Lincoln&apos;s bi-weekly briefing.</h3>
                  <p className="mt-2" style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>Case studies, deployment notes, voice-AI research. Read by 18,400 educators.</p>
                  <input placeholder="you@school.com" className="w-full text-white outline-none"
                    style={{ marginTop: 14, padding: '10px 14px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.18)', background: 'rgba(255,255,255,0.06)', fontSize: 13, fontFamily: 'inherit' }} />
                  <button type="button" className="lc-btn primary sm w-full mt-2">Subscribe</button>
                </div>

                <div style={{ background: 'var(--bg-cream)', borderRadius: 16, padding: 24, border: '1px solid var(--line)' }}>
                  <span className="font-bold tracking-widest" style={{ fontSize: 11, color: 'var(--muted)' }}>MOST READ</span>
                  <ol className="list-none p-0 flex flex-col gap-3.5 mt-3.5">
                    {BLOG_POSTS.slice(0, 5).map((p, i) => (
                      <li key={p.slug} className="flex gap-2.5">
                        <span className="font-serif font-bold leading-none flex-shrink-0"
                          style={{ fontSize: 24, color: 'var(--yellow-2)', width: 24 }}>0{i + 1}</span>
                        <Link to={`/blog/${p.slug}`} className="font-semibold leading-tight" style={{ fontSize: 13, color: 'var(--ink)' }}>{p.title}</Link>
                      </li>
                    ))}
                  </ol>
                </div>

                <div className="bg-white" style={{ borderRadius: 16, padding: 24, border: '1px solid var(--line)' }}>
                  <span className="font-bold tracking-widest" style={{ fontSize: 11, color: 'var(--muted)' }}>POPULAR TAGS</span>
                  <div className="flex flex-wrap gap-1.5 mt-3">
                    {['malta', 'finland', 'wef', 'vocational', 'voice-ai', 'multilingual', 'certificates', 'tutoring', 'ministry', 'policy', 'research'].map((t) => (
                      <a key={t} href="#" className="rounded-full font-semibold"
                        style={{ fontSize: 12, padding: '5px 10px', background: 'var(--bg-soft)', color: 'var(--ink-2)' }}>#{t}</a>
                    ))}
                  </div>
                </div>

                <div style={{ background: 'linear-gradient(135deg, var(--yellow), #f5c63a)', borderRadius: 16, padding: 24 }}>
                  <span className="font-bold tracking-widest" style={{ fontSize: 11, color: 'var(--navy)' }}>WORK BY COUNTRY</span>
                  <ul className="list-none p-0 mt-3.5 flex flex-col gap-1.5">
                    {[
                      { f: '🇲🇹', c: 'Malta',          n: 8 },
                      { f: '🇫🇮', c: 'Finland',        n: 14 },
                      { f: '🇺🇸', c: 'United States',  n: 6 },
                      { f: '🇵🇰', c: 'Pakistan',       n: 11 },
                      { f: '🌐', c: 'WEF / Global',   n: 5 },
                    ].map((r) => (
                      <li key={r.c} className="flex items-center gap-2.5"
                        style={{ padding: '6px 0', borderBottom: '1px solid rgba(11,31,56,0.12)' }}>
                        <span style={{ fontSize: 18 }}>{r.f}</span>
                        <span className="flex-1 font-semibold" style={{ fontSize: 14, color: 'var(--navy)' }}>{r.c}</span>
                        <span className="font-semibold" style={{ fontSize: 12, color: 'var(--ink-2)' }}>{r.n} stories</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function FeaturedPost({ post }) {
  return (
    <Link to={`/blog/${post.slug}`} className="grid items-center"
      style={{ gridTemplateColumns: '1.2fr 1fr', gap: 36, padding: 24, borderRadius: 24, background: 'var(--bg-cream)', border: '1px solid var(--line)' }}>
      <div className="relative overflow-hidden" style={{ height: 380, borderRadius: 18, background: 'var(--navy)' }}>
        <ImageSlot
          id={`blog-feat-${post.slug}`}
          style={{ position: 'absolute', inset: 0 }}
          shape="rounded"
          radius="18"
          src={post.photo}
          placeholder={`Drop hero image for "${post.title.slice(0, 30)}…"`}
        />
        <div className="absolute font-bold tracking-wider pointer-events-none"
          style={{ top: 16, left: 16, background: 'var(--yellow)', color: 'var(--navy)', padding: '6px 12px', borderRadius: 999, fontSize: 11 }}>★ FEATURED</div>
      </div>
      <div>
        <div className="flex items-center gap-2 mb-3.5">
          <span className="font-bold tracking-wider" style={{ fontSize: 11, color: post.cat_color }}>{post.category.toUpperCase()}</span>
          <span style={{ color: 'var(--muted)' }}>·</span>
          <span style={{ fontSize: 12, color: 'var(--muted)' }}>{post.tag}</span>
          <span style={{ color: 'var(--muted)' }}>·</span>
          <span style={{ fontSize: 12, color: 'var(--muted)' }}>{post.read} read</span>
        </div>
        <h2 style={{ fontSize: 44, letterSpacing: '-0.02em', lineHeight: 1.05 }}>{post.title}</h2>
        <p className="mt-4 leading-loose" style={{ fontSize: 16, color: 'var(--ink-2)' }}>{post.excerpt}</p>
        <div className="mt-6 flex items-center gap-3">
          <ImageSlot id={`author-${post.author.replace(/\s/g, '-')}`} style={{ width: 40, height: 40 }} shape="circle" src={post.authorPhoto} placeholder="" />
          <div>
            <div className="font-bold" style={{ fontSize: 13, color: 'var(--ink)' }}>{post.author}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>{post.author_role} · {post.date}</div>
          </div>
        </div>
      </div>
    </Link>
  );
}

function BlogListItem({ post }) {
  return (
    <Link to={`/blog/${post.slug}`} className="grid items-center"
      style={{ gridTemplateColumns: '200px 1fr', gap: 28, padding: '24px 0', borderBottom: '1px solid var(--line)' }}>
      <div className="relative overflow-hidden" style={{ height: 140, borderRadius: 12, background: 'var(--bg-soft)' }}>
        <ImageSlot id={`blog-thumb-${post.slug}`} style={{ position: 'absolute', inset: 0 }} shape="rounded" radius="12" src={post.photo} placeholder={post.tag} />
      </div>
      <div>
        <div className="flex items-center gap-2 mb-2.5">
          <span className="font-bold tracking-wider" style={{ fontSize: 11, color: post.cat_color }}>{post.category.toUpperCase()}</span>
          <span style={{ color: 'var(--muted)' }}>·</span>
          <span style={{ fontSize: 12, color: 'var(--muted)' }}>{post.tag}</span>
          <span style={{ color: 'var(--muted)' }}>·</span>
          <span style={{ fontSize: 12, color: 'var(--muted)' }}>⏱ {post.read}</span>
        </div>
        <h3 style={{ fontSize: 24, lineHeight: 1.2 }}>{post.title}</h3>
        <p className="mt-2 leading-relaxed" style={{ fontSize: 14, color: 'var(--muted)', maxWidth: 620 }}>{post.excerpt}</p>
        <div className="mt-3.5 flex items-center gap-2.5">
          <ImageSlot id={`author-li-${post.author.replace(/\s/g, '-')}`} style={{ width: 28, height: 28 }} shape="circle" src={post.authorPhoto} placeholder="" />
          <span className="font-semibold" style={{ fontSize: 12, color: 'var(--ink-2)' }}>{post.author}</span>
          <span style={{ fontSize: 12, color: 'var(--muted)' }}>· {post.date}</span>
        </div>
      </div>
    </Link>
  );
}
